import * as THREE from "three";
import { cloud, three, data, rt, audio } from "xx-packages";
const { cloudClient, typeManager } = cloud;





function createPlaneEdgeShaderMaterial(inputColor) {
  return new THREE.ShaderMaterial({
    uniforms: {
      uColor: { value: new THREE.Color(inputColor) },
    },
    vertexShader: `
      varying vec2 vUv;
      void main() {
        // Pass the UV coordinates to the fragment shader.
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: `
      uniform vec3 uColor;
      varying vec2 vUv;
      
      void main() {
    
        // Default color is white.
        vec3 color = vec3(1.0);
        vec2 uv = 2. * vUv - 1. ;
        uv.x = abs( uv.x );
        // float m = smoothstep( 0., 1. , pow( uv.x, 4.) ) ;
        float m = pow( uv.x, 4.);
        color = mix ( uColor, vec3( 1. ), m  );
        gl_FragColor = vec4(color, 1.0);
      }
    `
  });
}

const fresnelMat = baseColor => {


  const FresnelShader = {
    uniforms: {
      baseColor: { value: baseColor },
      fresnelColor: { value: new THREE.Color(0xffffff) },
      fresnelBias: { value: 0.1 },
      fresnelScale: { value: 0.5 },
      fresnelPower: { value: 2.0 },
    },
    vertexShader: `
    varying vec3 vWorldPosition;
    varying vec3 vNormal;

    void main() {
      // Transform the normal to view space
      vNormal = normalize(mat3(modelMatrix) * normal) ;
      // Compute the world position of the vertex
      vec4 worldPosition = modelMatrix * vec4(position, 1.0);
      vWorldPosition = worldPosition.xyz;
      // Standard transformation
      gl_Position = projectionMatrix * viewMatrix * worldPosition;
    }
  `,
    fragmentShader: `
    uniform vec3 baseColor;
    uniform vec3 fresnelColor;
    uniform float fresnelBias;
    uniform float fresnelScale;
    uniform float fresnelPower;
    varying vec3 vWorldPosition;
    varying vec3 vNormal;

    void main() {
      // Compute the view direction from the fragment to the camera
      vec3 viewDir = normalize(cameraPosition - vWorldPosition);
      // Calculate the Fresnel effect based on the angle between view direction and surface normal
      float fresnel = fresnelBias + fresnelScale * pow(1.0 - dot(viewDir, vNormal), fresnelPower);
      // Blend the base and Fresnel colors
      vec3 color = mix(baseColor, fresnelColor, fresnel);
      gl_FragColor = vec4(color, 1.0);
    }
  `,
  };

  return new THREE.ShaderMaterial(FresnelShader);
}

export default class DentsuTunnel extends window.VisComp {
  start() {
    super.start()
    this.inputs.setAutoUpdate(true)
    window.addEventListener('keydown', this.onKeyDown)
    this.createData();
    const link = document.createElement('link');
link.href = 'https://use.typekit.net/onb5oxp.css';
link.rel = 'stylesheet';

document.getElementsByTagName('head')[0].appendChild(link);



    this.createStartScreen()
 
    this.createHTMLOverlay()

    // https://protectwise.github.io/troika/troika-three-text/
    // Create:
    /*
    const myText = new Text()
    this.cont3D.add(myText)

    // Set properties to configure:
    myText.text = 'Lofasz a seggedbe!'
    myText.fontSize = 1
    myText.position.z = -10
    myText.color = 0x9966FF
    myText.anchorX = 'center'
    myText.anchorY = 'middle'

    // Update the rendering:
    myText.sync()
    */
    switch(this.mode){
      case 1:
         this.lineLength = 12
          this.lineAngle = 50 / 180 * Math.PI;
          break;
      case 2:
        this.lineLength = 50
        this.lineAngle = 50 / 180 * Math.PI;
      break;
    }
    

    this.materials = [];
    //console.log("COLORs",this.lineColors);
    for (let i = 0; i < this.lineColors.length; i++) {
      let mat = new THREE.MeshBasicMaterial({ color: this.lineColors[i], side: THREE.DoubleSide });
      mat = createPlaneEdgeShaderMaterial( this.lineColors[i])
      this.materials.push(mat);
    }
    this.matRound = [];
    //console.log("COLORs",this.lineColors);
    console.log(this.imgRound[0]);

    for (let i = 0; i < this.imgRound.length; i++) {
      let mat = new THREE.MeshBasicMaterial({ map: this.imgRound[i], side: THREE.DoubleSide, transparent: true });
      this.matRound.push(mat);
    }
    // this.matBall = new THREE.MeshBasicMaterial({color:this.ballColors[0]});
    // this.matBall2 = new THREE.MeshBasicMaterial({color:0xffffff});

    this.matBall = fresnelMat(this.ballColors[0])
    this.matBall2 = fresnelMat(new THREE.Color(0xffffff))

    this.geomBall = new THREE.SphereGeometry(1.2);
    this.geomLine = new THREE.PlaneGeometry(0.7, this.lineLength);
    this.lineLength2 = 50
    this.geomLine2 = new THREE.PlaneGeometry(0.7, this.lineLength2);
    this.geomRound = new THREE.RingGeometry(0, 6, 32, 1);

    // generate ornaments ////////////////////////////////////////////////
    /*
    this.time=0;
    this.aniLines2=[];
    for (let i = 0; i < 19; i++) {
      let line = new THREE.Mesh(this.geomLine2, this.materials[i % this.materials.length]);
      this.cont3D.add(line);
      let ball1 = new THREE.Mesh(this.geomBall, this.matBall);
      line.add(ball1);
      ball1.position.y = this.lineLength2 / 2;
      let ball2 = new THREE.Mesh(this.geomBall, this.matBall);
      line.add(ball2);
      ball2.position.y = -this.lineLength2 / 2;
      let alpha=-Math.PI*2/20*(i)+Math.PI;
      line.position.set(Math.sin(alpha)*40,-30,Math.cos(alpha)*40);
      line.rotation.set(Math.PI/2,0,-alpha);
      this.aniLines2.push(line);
    }
    this.aniLines=[];
    for (let i = 0; i < 19; i++) {
      let line = new THREE.Mesh(this.geomLine2, this.materials[(i) % this.materials.length]);
      this.cont3D.add(line);
      let ball1 = new THREE.Mesh(this.geomBall, this.matBall);
      line.add(ball1);
      ball1.position.y = this.lineLength2 / 2;
      let ball2 = new THREE.Mesh(this.geomBall, this.matBall);
      line.add(ball2);
      ball2.position.y = -this.lineLength2 / 2;
      let alpha=-Math.PI*2/20*(i)+Math.PI;
      line.position.set(Math.sin(alpha)*40,-13,Math.cos(alpha)*40);
      line.rotation.set(-Math.PI/2,0,alpha);
      this.aniLines.push(line);
    }
    */

    this.lines = [];
    this.clickableObjects = [];
    this.count = 19;
    for (let i = 0; i < this.count; i++) {
      let side = ((i % 2) * 2 - 1);
      if(this.mode==1) side=0;
      let line = new THREE.Mesh(this.geomLine, this.materials[i % this.materials.length]);
      this.cont3D.add(line);
      let ball1 = new THREE.Mesh(this.geomBall, this.matBall);
      line.add(ball1);
      ball1.position.y = this.lineLength / 2;
      let ball2 = new THREE.Mesh(this.geomBall, this.matBall);
      line.add(ball2);
      ball2.position.y = -this.lineLength / 2;
      let round = new THREE.Mesh(this.geomRound, this.matRound[i % this.matRound.length]);
      line.add(round);
      //round.position.set(9,this.lineLength/2*side,0);
      round.position.set(12, this.lineLength / 2 * side, 0);
      round.rotation.z = -Math.PI / 2;
       if(this.mode==2) round.rotation.x = -Math.PI / 4 * side;
      round.name = i % this.content.length;
      this.clickableObjects.push(round);
      let texYear = new Text()
      line.add(texYear);

      // Set properties to configure:
      texYear.font = "https://dwohp4umqrwym.cloudfront.net/clients/dentsu/halcom.woff"
      texYear.text = this.content[i % this.content.length].year;
      texYear.fontSize = 2
      texYear.fontFamily="Verdana";
      // texYear.position.set(-3,this.lineLength/2*side,0);
      texYear.position.set(3.3, this.lineLength / 2 * side, 0);
      texYear.rotation.z = -Math.PI / 2;// + 0.06;
      if(this.mode==2) texYear.rotation.x = -Math.PI / 4 * side;
      texYear.color = 0xffffff;
      texYear.anchorX = 'center'
      texYear.anchorY = 'middle'
      texYear.sync()

      let alpha = Math.PI * 2 / 6.7 * i;
      let ll = {
        line, ball1, ball2, round,
        xR: Math.random() * 40 - 20,
        yR: Math.random() * 40 - 20,
        rotZR: Math.random() * Math.PI,
        rotYR: 0,
        zR: (1 - i / this.count * 2) * 300
      }

      switch (this.mode) {
        // Tunnel
        case 0:
          ll.xT = Math.sin(alpha) * 20;
          ll.yT = Math.cos(alpha) * 20;
          ll.zT = ll.zR;
          ll.rotZT = (Math.PI * 2 - alpha + Math.PI / 2) % Math.PI;
          ll.rotYT = 0;

          break;

        // Spiral
        case 1:
          alpha = -Math.PI * 2 / 20 * i - 3.14; // add -3.14 so we start on correct elem of timeline
          let radius = 50;
          ll.xT = Math.sin(alpha) * radius;
          ll.yT = - 5// + i / this.count * 60
          ll.zT = Math.cos(alpha) * radius;
          ll.rotZT = Math.PI / 2;// - 0.07;
          ll.rotYT = (alpha + Math.PI / 2 + Math.PI / 2) % (Math.PI * 2);
          break;

        // ZigZag
        case 2:
          alpha = Math.PI * 2 / 12 * i;

          ll.xT = 0;//side*4;
          ll.yT = -6;
          //   ll.zT=-45-i*18.5;
          ll.zT = -65 - Math.sin(this.lineAngle) * this.lineLength * i;
          ll.rotZT = Math.PI / 2;
          ll.rotYT = this.lineAngle * side;
          break;
      }

      this.lines.push(ll);
    }
    this.state = 1;
    this.stateAni = 1;
    this.updateComp();
    this.addDomListeners();
    this.initRaycaster();
    // this.objBox = new THREE.Mesh(this.geom,this.mat);
    //this.cont3D.add(this.objBox);
  }
  createStartScreen(){
    const container = document.createElement('div')
    container.addEventListener('click', _=>{
      container.style.opacity = 0
      container.style.pointerEvents = 'none'
      setTimeout(_=>{
        container.remove()
      }, 1000 )
    })
    container.classList.add('StartScreen')
    container.innerHTML = `
      <div class='BG'></div>
      <div>
        <p>This experience requires gyroscope access.</p>
        <p>Please click start and accept permissions.</p>
        <p>Move your phone to look around, tap and rag to rotate the content.</p>
        <p>Click images for more information.</p>
        <button>Start</button>
      </div>
    `
    document.body.append( container )


    const tilt = document.createElement('div')
    tilt.style = `
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translate( -50% , 0);
    background-color: white;
    color: black;
    padding: 1em;
    border-radius: 5px;
    max-width: 22em;
    font-size: 16px;
    text-align: center;
    transition: opacity 0.5s;
    opacity: 0;
    `
    tilt.textContent = 'Please tilt your phone to see the timeline.'
    document.body.append( tilt )
    this.tilt = tilt 
  }
  updateComp() {
    let v0 = 1 - this.stateAni;
    let v1 = this.stateAni;
    for (let i = 0; i < this.lines.length; i++) {
      this.lines[i].round.material.opacity = v1;
      let line = this.lines[i].line;
      let ball1 = this.lines[i].ball1;
      let ball2 = this.lines[i].ball2;
      let xR = this.lines[i].xR;
      let yR = this.lines[i].yR;
      let rotZR = this.lines[i].rotZR;
      let rotYR = this.lines[i].rotYR;
      let xT = this.lines[i].xT;
      let yT = this.lines[i].yT;
      let rotZT = this.lines[i].rotZT;
      let rotYT = this.lines[i].rotYT;
      let zR = this.lines[i].zR;
      let zT = this.lines[i].zT;
      line.position.set(xR * v0 + xT * v1, yR * v0 + yT * v1, zR * v0 + zT * v1);
      line.rotation.z = rotZR * v0 + rotZT * v1;
      line.rotation.y = rotYR * v0 + rotYT * v1;
    }
   
  }
  inputChanged(event) {
    // if(event.type="balance") this.resetComp();
    /*
    switch(event.type){
        case "mat":
  
            this.objBox.material = this.mat;
        break;
        case "geom":
       
            this.objBox.geometry = this.geom;
        break;
    
    }*/
  }
  onKeyDown = e => {
    console.log(e.code)
    if (e.code === 'Space') {
      this.state = (this.state + 1) % 2;
      // this.stateAni=this.state;
      this.updateComp();
    }
    //if (e.code === 'KeyM') 

  }
  update(dt) {
    super.update(dt)
    /*
    this.time+=dt;
    //decoration
    for (let i = 0; i < 19; i++) {
      let line = this.aniLines[i];
       let line2 = this.aniLines2[i];
       let line3 = this.lines[i].line;
      let alpha=-Math.PI*2/20*(i*2)+Math.PI;
      line.position.y=-18+Math.sin(this.time+alpha)*2;
       line2.position.y=26+Math.sin(-this.time+alpha)*2;
      // line3.position.y=-5+Math.sin(this.time+alpha);
    //  line.position.y = Math.random()*10;
     // line.rotation.set(-Math.PI/2,0,alpha);
     
    }
*/

    if (Math.abs(this.state - this.stateAni) > 0.005) {
      this.stateAni += (this.state - this.stateAni) * 0.05;
      this.updateComp();
    } else {
      this.stateAni = this.state;
    }
    this.raycast();
    //this.objBox.rotation.y+=dt*this.rotSpeed;
    if ( this?.me?.ctrl?.deviceOrientation?.beta === undefined ) return 
        if ( this?.me?.ctrl?.deviceOrientation?.beta === null ) return 

    const angle = this?.me?.ctrl?.deviceOrientation?.beta
    if ( angle > 60 )return this.tilt.style.opacity = 0 
    this.tilt.style.opacity = 1

   
  }

  addDomListeners() {
    this.domListeners = {
      mousedown: this.onMouseDown.bind(this),
      mousemove: this.onMouseMove.bind(this),
      mouseup: this.onMouseUp.bind(this),
      mouseleave: this.onMouseLeave.bind(this),
      mouseenter: this.onMouseEnter.bind(this),
    };
    for (let event in this.domListeners) {
      document.addEventListener(event, this.domListeners[event], false);
    }

    this.mouse = {
      x: 10000,
      y: 10000,
      buttonDown: false,
      onCanvas: true,
    };

  }
  removeDomListeners() {
    console.log("REMOVED DOM LISTENERS ");

    for (let event in this.domListeners) {
      document.removeEventListener(event, this.domListeners[event], false);
    }
  }

  onMouseDown() {
    this.mouse.buttonDown = true;
    this.mouseDownSelectedItemInd = this.selectedItemInd;
  }
  onMouseUp() {
    this.mouse.buttonDown = false;
    if (this.overlayOn) {
      this.hideHTMLOverlay();
    } else {
      if (this.selectedItemBool && this.mouseDownSelectedItemInd == this.selectedItemInd) {
        this.showHTMLOverlay(this.selectedItemInd);
      }
    }
  }
  onMouseLeave() {
    this.mouse.onCanvas = false;
  }
  onMouseEnter() {
    this.mouse.onCanvas = true;
  }
  onMouseMove(event) {
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  }

  //RayCasting
  initRaycaster() {
    this.raycaster = new THREE.Raycaster();
  }

  raycast() {
    this.selectedItemInd = -1;
    this.selectedItemBool = false;
    if (!this.overlayOn) {
      let inter = [];
      if (this.mouse.onCanvas) {
        this.raycaster.setFromCamera(this.mouse, this.renderer.camera);
        inter = this.raycaster.intersectObjects(this.clickableObjects, false);
      }
      for (let i = 0; i < this.clickableObjects.length; i++) {
        this.clickableObjects[i].scale.set(1, 1, 1);
      }
      if (inter.length > 0) {
        let ss = 1.1;
        inter[0].object.scale.set(ss, ss, ss);
        this.selectedItemInd = inter[0].object.name;
        this.selectedItemBool = true;
      }
    }
    /*
//filter-out inactive objects
if (inter != null || inter.length > 0) {
  let finter = [];
  for (let i = 0; i < inter.length; i++)
    if (this.elems[inter[i].object.userData.ind].active)
      finter.push(inter[i]);
  inter = finter;
}
if (this.mouseInNav) inter = [];
//console.log("Inter",inter);
// No hit //////////////////////////////////
if (inter == null || inter.length == 0) {
  if (this.picMouseOver >= 0) this.elemOffHover(this.picMouseOver);
  this.picMouseOver = -1;
  this.mouseHoverTime = 0;
  document.body.classList.remove("PhotoGallery-PointerCursor");
  return;
}

// Hit ////////////////////////////////////
let obj = inter[0].object;
//console.log("HIT",obj);

//Was mouse over previosly?
if (this.picMouseOver >= 0) {
  if (this.picMouseOver !== obj.userData.ind) {
    this.elemOffHover(this.picMouseOver);
    this.mouseHoverTime = 0;
    this.picMouseOver = obj.userData.ind;
    this.elemOnHover(this.picMouseOver);
  }
} else {
  this.picMouseOver = obj.userData.ind;
  this.elemOnHover(this.picMouseOver);
}
document.body.classList.add("PhotoGallery-PointerCursor");
*/
  }
  createHTMLOverlay() {
    this.divOverlay = document.createElement("div");
    this.divOverlay.style.position = "fixed";
     this.divOverlay.style.top = 0;
       this.divOverlay.style.left = 0;
    this.divOverlay.style.width = "100%";
    this.divOverlay.style.height = "100%";
    this.divOverlay.style.backgroundColor = "rgba(0,0,0,0.75)";
    this.divOverlay.style.display = "none";
    document.body.appendChild(this.divOverlay);

    this.divContent = document.createElement("div");
    this.divContent.style.position = "absolute";
    this.divContent.style.width = "80%";
    this.divContent.style.height = "85%";
    this.divContent.style.left = "50%";
    this.divContent.style.top = "50%";
    this.divContent.style.transform = 'translate(-50%,-50%)'
    this.divContent.style.padding = "5%";
    this.divContent.style.border = "1px solid #ffffff";
    this.divContent.style.backgroundColor = "rgba(0,0,0,0.75)";
    this.divContent.style.color = "#ffffff";
    this.divContent.style.textAlign = "center";
    this.divContent.style.overflowY = "auto";
    this.divContent.style.boxSizing = "border-box";
    this.divOverlay.appendChild(this.divContent);

    this.imgContent = document.createElement("img");
    this.imgContent.style.width = "100%";
    this.divContent.appendChild(this.imgContent);
    this.divText = document.createElement("div");
    this.divContent.appendChild(this.divText);
    this.overlayOn = false;
  }
  showHTMLOverlay(ind) {
    let data = this.content[ind];
    this.divOverlay.style.display = "block";
    this.divText.innerHTML = "<h1>" + data.year + "</h1><p>" + data.text + "</p>";
    this.imgContent.src = "https://res.cloudinary.com/webremixernew/image/upload/" + this.imgLand[ind].userData.doc.d.baseObj.asset[">ext"].id + ".jpg";
    // this.imgContent.src=this.imgLand[ind].userData.doc.d.baseObj.asset[">ext"].url;
    this.overlayOn = true;
  }
  hideHTMLOverlay() {
    this.divOverlay.style.display = "none";
    this.overlayOn = false;
  }

  createData() {
    this.content = [
      {
        year: "1901",
        title: "Dentsu's History Begins in 1901, at the Dawn of the Twentieth Century",
        text: "Dentsu's founder, Hoshio (also referred to as 'Hoshio' in some documents) Mitsunaga (1866–1945), had served as a war correspondent, giving him a taste of the world of news reporting. These experiences led him to the idea of starting a news agency to supply newspaper companies with news and information. In 1901, to generate the income needed to support a news operation, he launched his business by setting up an agency to sell newspaper advertisements. Soon after, he established a news agency."
      },
      {
        year: "1947",
        title: "He Devoted His Entire Life to the Modernization of Japan's Advertising Industry",
        text: "By the time the Second World War ended, much of Ginza lay in smoldering ruin. Miraculously, the Dentsu Head Office Building had survived, and it was from here that the Company began its post-war era. In June 1947, Hideo Yoshida (1903–1963) became Dentsu's fourth president. Yoshida was determined to transform Japanese advertising into a modern, scientific business. Under Yoshida's resolute leadership, the atmosphere inside the Company brimmed with a sense of vitality, and the number of Dentsu employees grew rapidly."
      },
      {
        year: "1964",
        title: "Tokyo Olympic Games–The World Comes Together",
        text: "In 1964, Japan hosted its first major international sports event, the Tokyo Olympic Games. The entire country was swept up by the spectacle and drama that unfolded daily during live color television broadcasts and unprecedented newspaper coverage. Dentsu threw the weight of its entire organization into ensuring that the Games were a great success, and demonstrated to the Japanese advertising industry the new business potential offered by such events."
      },
      {
        year: "1978",
        title: "Advertising Agency to a Communications Company",
        text: "From an advertising agency to a communications company. In 1978, Dentsu changed its English corporate name from Dentsu Advertising Ltd. to Dentsu Incorporated, signifying the beginning of its transformation into a communications company. The Company rapidly expanded its business domains as it began working with emerging new media and stepped up its involvement in large-scale public sector-led regional promotion projects."
      },
      {
        year: "2009",
        title: "Good Innovation",
        text: "Dentsu adopted a new corporate philosophy with the slogan 'Good Innovation.' . In 2009, the Group adopted a new corporate philosophy with the slogan 'Good Innovation.' This philosophy defined the Dentsu Group's overall business domain as 'Integrated Communication Design,' which means generating optimal integrated solutions in Japan and the global market, covering all spheres from management issues faced by clients to communications."
      },
    ];

    this.content = [
      {
        "year": "1901",
        "text": "Dentsu's history dates back to 1901 when the business was founded as an agency selling newspaper advertisements to generate the necessary income to support a news operation. Shortly after, a news agency was formed, and the two companies later merged to create Nippon Dempo Tsushin-sha (Japan Telegraphic Communication Co., Ltd., later known as \"dentsu\"). This marked the beginning of the chapter in which dentsu operated as both a news agency and an advertising agency.",
        "img": ""
      },
      {
        "year": "1936",
        "text": "As the second world war loomed, the Japanese government pressed for the merger of the news agency operations of the country's two largest agencies at the time. Dentsu and Nippon Shimbun Rengosha became a single, powerful, national news agency.<br><br>As a result, on June 1, 1936, dentsu was reborn as a company specialising exclusively in advertising. Our business quickly expanded to become the leading company in Japan’s advertising industry.",
        "img": ""
      },
      {
        "year": "1947 - 1953",
        "text": "We underwent significant modernisation and growth, shaping Japanese advertising into a modern, scientific business. The company was awash with energy, creativity and innovative ideas, and the number of dentsu employees grew rapidly.",
        "img": ""
      },
      {
        "year": "1955",
        "text": "In 1955, the first year of Japan's record-breaking period of rapid economic growth, the Company's official name was changed to Dentsu Advertising Ltd. the abbreviated name by which it had long been known. 20 years after becoming a company focused exclusively on advertising, Our path towards dentsu as the modern advertising company we know today began to take shape.",
        "img": ""
      },
      {
        "year": "1959",
        "text": "In 1959, as Japan took steps toward becoming more integrated into the world economy, we established our initial overseas presence by opening a New York Office. Subsequently, we built up a network of offices in Europe, North America and Asia.",
        "img": ""
      },
      {
        "year": "1964-1974",
        "text": "A decade of milestones, during which we became the world's largest advertising agency. Japan's rapid economic growth during this era helped drive a continuous stream of robust operating results at dentsu. In 1974, two leading American periodicals, TIME and Advertising Age, reported that dentsu had risen to the number one spot among worldwide advertising agency rankings (based on calendar 1973 billings).",
        "img": ""
      },
      {
        "year": "1978",
        "text": "In 1978, we changed our English corporate name from dentsu Advertising Ltd. to dentsu Incorporated, signifying the beginning of our transformation into a communications company. We rapidly expanded our business domains as we began working with emerging new media.",
        "img": ""
      },
      {
        "year": "1998",
        "text": "In 1998, when the unprecedented turbulence following the collapse of the bubble economy had finally settled, mega-agencies began to make inroads into the Japanese market. We recognised that the trend towards globalisation in the coming years would be crucial in how to shape our future for the next century.",
        "img": ""
      },
      {
        "year": "2001",
        "text": "In 2001, the centenary year of our founding, we made our debut on the First Section of the Tokyo Stock Exchange (TSE). This began a new chapter in our history as we became a public company, with an enhanced ability to contribute to society.",
        "img": ""
      },
      {
        "year": "2005",
        "text": "In 2005, we gained ISO 14001 certification as part of our efforts to address global environmental issues. In 2008, an internal committee for the development of environment-related strategies was established to further bolster our capabilities to address sustainability issues. In the same year, we became the first agency from the advertising industry to be recognised as an eco-first company under the Eco-First Programme established by the Japanese Ministry of the Environment.",
        "img": ""
      },
      {
        "year": "2009",
        "text": "In 2009, we adopted a new corporate philosophy with the slogan \"Good Innovation.\" This philosophy defined our overall business domain as \"Integrated Communication Design,\" generating optimal integrated solutions in Japan and the global market.",
        "img": ""
      },
      {
        "year": "2007-2010",
        "text": "Enhancing our global network, we focused on driving growth through globalisation and digitisation. Key moves included acquisitions in the UK and the US, restructuring our European operations, and expanding our presence in Europe and the Americas. Additionally, we reinforced our business infrastructure in emerging economies like China, India, and ASEAN countries, which are rapidly redrawing the global economic landscape.<br><br>We established Dentsu Digital Holdings Inc. in 2009. In unifying our digital business divisions, we provided the most sophisticated digital solutions possible under a structure that ensured swift, flexible planning and execution capabilities.",
        "img": ""
      },
      {
        "year": "2013",
        "text": "On July 12, 2012, the boards of Dentsu Inc. and Aegis Group plc jointly announced that they had reached agreement on the terms of a recommended cash offer by Dentsu for Aegis. Aegis shareholders approved the transaction at shareholder meetings on August 16, 2012. The acquisition was completed on March 26, 2013, and a new global operating unit, Dentsu Aegis Network Ltd., was established in London.",
        "img": ""
      },
      {
        "year": "2014",
        "text": "Founded in 2014, Dentsu Lab Tokyo has transformed the intersection of technology and creativity, tackling societal challenges and crafting visionary responses that resonate deeply. With a diverse team of global innovators and dreamers, armed with cutting-edge technology, the lab innovates to drive client growth while making a meaningful impact on society.",
        "img": ""
      },
      {
        "year": "2021",
        "text": "In 2021, we established a group-wide vision with the tagline \"an invitation to the never before.\" All dentsu brands now create unprecedented value through a shared code of conduct, \"The 8 ways\", that expresses universal values and ways of working.",
        "img": ""
      },
      {
        "year": "2023",
        "text": "In 2023, we transitioned to a global management structure under One Management Team, and 2024 saw the introduction of the One dentsu Operating Model, a common business management model across all four global regions. This enables us to globally consolidate customer touchpoints, promote faster delivery of diverse and advanced practices, and further elevate operational efficiency. We go-to-market through a multi-brand or “two-door approach, that allows all our clients to enter through any one brand and gain access to all of dentsu.<br><br>Dentsu is our master brand - a critical point of connection and equity for our global leadership brands as our hallmark of innovation and global scale.<br><br>Our leadership brands in the UK are Carat, dentsu X, iProspect, Dentsu Creative, and Merkle. Each leverages solutions, services, products, and platforms to deliver differentiated offerings to our clients and attract talent to our organisation.",
        "img": ""
      },
      {
        "year": "2023",
        "text": "We announced a globally diverse and integrated leadership team to drive our global business forward from FY2023. Hiroshi Igarashi, President & CEO, said \"We have formed a global Group Management Team to further contribute to our clients' business growth and the realisation of a better society by strengthening our Integrated Growth Solutions, and to enhance our corporate value.\"",
        "img": ""
      },
      {
        "year": "2024",
        "text": "Building on the success of our pioneering Lab in Tokyo, Dentsu Lab London opened, expanding our global creative R&D capabilities and giving brands the edge they need to stay ahead in an era of rapid technological change. Innovation isn't optional; it's essential for brands looking to remain relevant, differentiate from competitors, and create meaningful customer experiences.<br><br>We launched in collaboration with On, Virgin, and Microsoft, three industry leaders who share our vision for groundbreaking innovation. Our Lab provides exclusive access to emerging technologies, expert collaboration, and cutting-edge experimentation, helping future-proof brands and unlock new growth opportunities.",
        "img": ""
      },
      {
        "year": "2024",
        "text": "The evolution of One dentsu shone a light on the requirement to have a truly global value proposition. Last year, we announced our new go-to-market proposition, Innovating to Impact -bringing to life the power of our Integrated Growth Solutions to drive growth through innovation, technology and creativity.",
        "img": ""
      }
    ];
  }
}


typeManager.registerClass("677dc19c3543653d1629e4eb", DentsuTunnel);
